// extracted by mini-css-extract-plugin
export var csatScore = "_kl-5";
export var header = "_kl-1";
export var panelWrapper = "_kl-2";
export var postPreview = "_kl-3";
export var rightContent = "_kl-0";
export var wrappingText = "_kl-4";